import get from 'lodash/get';
import React, { useContext, useEffect, useRef } from 'react';
import { GiHamburgerMenu } from 'react-icons/gi';
import { IoMdClose } from 'react-icons/io';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';

import Logo from 'src/components/Logo';
import { AppContext } from 'src/containers/Core/AppContext';
import { setLeftMenuVisibility } from 'src/containers/Core/AppReducer';
import { AppViewContext } from 'src/containers/Core/AppView';

import style from './style.module.scss';

const Header: React.FunctionComponent<RouteComponentProps> = () => {
  const { isPhoneView } = useContext(AppViewContext);
  const { store, dispatch } = useContext(AppContext);
  const { sourceEntity, leftMenuVisibility } = store;
  const headerRef = useRef(null);
  const menuRef = useRef(null);

  // change below code ******
  const logoLink = `isPhoneView ? getEntitiesRoute() : isCityWorkspace ? HOME : BUSINESS_PROFILE`;
  const linkStyle = { textDecoration: 'none' };

  const handleClick = (event: Event) => {
    if (
      menuRef &&
      menuRef.current &&
      headerRef &&
      headerRef.current &&
      !menuRef.current.contains(event.target) &&
      headerRef.current.contains(event.target)
    ) {
      dispatch(setLeftMenuVisibility(false));
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);

  const handleIconClick = () => {
    if (leftMenuVisibility) {
      setLeftMenuVisibility(false);
    } else {
      setLeftMenuVisibility(true);
    }
  };

  return (
    <div className={`header-container bg-menu-dark d-flex p-2`} ref={headerRef}>
      {isPhoneView ? (
        <span className="mr-2 align-self-center text-white" onClick={() => handleIconClick()} ref={menuRef}>
          {leftMenuVisibility ? (
            <IoMdClose size={25} className="c-pointer" />
          ) : (
            <GiHamburgerMenu size={25} className="c-pointer" />
          )}
        </span>
      ) : null}
      <Link
        className={`${
          style.title
        }  d-flex text-decoration-none p-0 align-items-center align-self-center flex-fill mr-auto w-100 ${
          isPhoneView ? 'text-truncate' : ''
        }`}
        style={linkStyle}
        to={logoLink}
      >
        <Logo
          height={30}
          width={30}
          imageSrc={get(sourceEntity, 'logo')}
          text={get(sourceEntity, 'name')}
          className="ml-2 mr-3"
          inverse={true}
        />
      </Link>
    </div>
  );
};

export default withRouter(Header);
